module.exports = __webpack_public_path__ + "media/images/icons/icn_034-528fc198607058b72621b978005ff297.svg";